// announcemnet bar scrolling height & Header height

const announcementBar = document.querySelector(".announcement-bar");

function updateVisibleHeight() {
  const rect = announcementBar.getBoundingClientRect();

  const visible = Math.max(
    0,
    Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
  );
  document.documentElement.style.setProperty('--announcement-visible-height', Math.round(visible) + "px");
}

window.addEventListener("scroll", updateVisibleHeight);
window.addEventListener("resize", updateVisibleHeight);
updateVisibleHeight();

const header_heigt = document.querySelector("#HeaderWrapper");
const headerHeight = header_heigt.offsetHeight;
document.documentElement.style.setProperty('--window-scroll-height', window.scrollY + "px");
window.addEventListener("scroll", () => {
  document.documentElement.style.setProperty('--window-scroll-height', window.scrollY + "px");
});
 document.documentElement.style.setProperty('--header-height', headerHeight + "px");


// Details and summary
const detailsList = document.querySelectorAll("details");
detailsList.forEach((detail) => {
  detail.addEventListener("toggle", () => {
    if (detail.open) {
      detailsList.forEach((other) => {
        if (other !== detail) {
          other.removeAttribute("open");
        }
      });
    }
  });
});

document.addEventListener("click", (e) => {
  detailsList.forEach((detail) => {
    if (detail.open && !detail.contains(e.target)) {
      detail.open = false;
    }
  });
});


class DetailsSummary extends HTMLElement {
  constructor() {
    super();
    const detailsList = this.querySelectorAll("details");
      detailsList.forEach((detail) => {
        detail.addEventListener("toggle", () => {
          if (detail.open) {
            detailsList.forEach((other) => {
              if (other !== detail) {
                other.removeAttribute("open");
              }
            });
          }
        });
      });

      document.addEventListener("click", (e) => {
        detailsList.forEach((detail) => {
          if (detail.open && !detail.contains(e.target)) {
            detail.open = false;
          }
        });
      });
  }
}

customElements.define("details-wrappper", DetailsSummary);

const openBtn = document.querySelector('.js-drawer-open-nav');
const headerDrawer = document.querySelector('.header-drawer');

openBtn.addEventListener('click', () => {
  headerDrawer.classList.toggle('is-open');
});

class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    const allDetails = this.querySelectorAll("details");

    allDetails.forEach((detail) => {
      const content = detail.querySelector(".menu-drawer-content");
      const summary = detail.querySelector("summary");
      const menuTitle = detail.querySelector(".menu-title");

      if (!content || !summary) return;
      detail.addEventListener("toggle", () => {
        if (detail.open) {
          this.slideIn(content);
        } else {
          this.slideOut(detail, content);
        }
      });
      if (menuTitle) {
        menuTitle.addEventListener("click", (e) => {
          e.stopPropagation();
          this.slideOut(detail, content);
        });
      }
    });
  }

  slideIn(content) {
    content.animate(
      [
        { transform: "translateX(100%)" },
        { transform: "translateX(0)" }
      ],
      {
        duration: 350,
        easing: "ease-out"
      }
    );
  }

  slideOut(detail, content) {
    const anim = content.animate(
      [
        { transform: "translateX(0)" },
        { transform: "translateX(100%)" }
      ],
      {
        duration: 300,
        easing: "ease-in"
      }
    );

    anim.onfinish = () => {
      detail.removeAttribute("open");
    };
  }
}

customElements.define("header-drawer", HeaderDrawer);

class HeroImageCarousel extends HTMLElement {
  constructor() {
    super();
    const autoRotate = this.getAttribute("data-autoplay");
    const swiper = new Swiper(".js-hero-image-carousel", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      a11y: true,
      autoplay: autoRotate ? { delay: Number(autoRotate) } : false,
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
}

customElements.define("hero-image-carousel", HeroImageCarousel);


const sortBy = document.querySelector(".filter-sort-by");

if (sortBy) {
  const params = new URLSearchParams(window.location.search);
  const sortValue = params.get("sort_by");

  if (sortValue) {
    const matchingOption = sortBy.querySelector(`option[value="${sortValue}"]`);
    if (matchingOption) {
      matchingOption.setAttribute("selected", "selected");
    }

    const hiddenValue = sortBy.querySelector(".hidden-value");
    if (hiddenValue) {
      hiddenValue.removeAttribute("selected");
    }
  }
  sortBy.addEventListener("change", () => {
    const windowUrl = window.location.href;

    if (windowUrl.includes("sort_by")) {
      const hiddenValue = sortBy.querySelector(".hidden-value");
      if (hiddenValue) {
        hiddenValue.removeAttribute("selected");
      }
    }
  });
}




class RadioSwitch extends HTMLElement {
  constructor() {
    super();
      const switches = this.querySelectorAll(".radio-switch");
      const availabilityTag = document.querySelector(".availablity-tag .tag__checkbox-wrapper");

    if (switches.length > 0 && availabilityTag) {
      switches.forEach((sw) => {
        sw.addEventListener("click", () => {
          availabilityTag.click();
        });
        const windowUrl = window.location.href;
        setTimeout(() => {
            const windowUrl = window.location.href;

            if (windowUrl.includes("filter.v.availability")) {
              sw.classList.add("active");
            } else {
              sw.classList.remove("active");
            }
          }, 200);
      }); 
    }
  }
}

customElements.define("radio-switch", RadioSwitch);

class MainProductCarousel extends HTMLElement {
  constructor() {
    super();
      const tabletQuery = window.matchMedia('(min-width: 769px)');
      if(tabletQuery.matches){
        const thumbnails = this.querySelectorAll('.product__thumb-item');
        const stickyHeaderHeight = 100;

        let activeThumb = null;

        thumbnails.forEach(thumb => {
            if (thumb.classList.contains('active-thumb')) {
                activeThumb = thumb;
            }
            if (!activeThumb && thumb === thumbnails[0]) {
                thumb.classList.add('active-thumb');
                activeThumb = thumb;
            }

            thumb.addEventListener('click', function(e) {
                e.preventDefault();

                if (activeThumb) {
                    activeThumb.classList.remove('active-thumb');
                }

                this.classList.add('active-thumb');
                activeThumb = this;

                const targetId = this.getAttribute('data-thumb-id');
                const targetMainImage = document.querySelector(`[data-main-id="${targetId}"]`);

                if (targetMainImage) {
                    const elementPosition = targetMainImage.getBoundingClientRect().top;
                    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

                    const offsetPosition = elementPosition + currentScroll - stickyHeaderHeight;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error(`Main image not found for ID: ${targetId}`);
                }
            });
        });


        const scrollToVariantImage = (variantId) => {
            setTimeout(() => {
                const targetVariantImage = document.querySelector(`[data-variant-id*="${variantId}"]`);

                if (targetVariantImage) {
                    const elementPosition = targetVariantImage.getBoundingClientRect().top;
                    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

                    const offsetPosition = elementPosition + currentScroll - stickyHeaderHeight;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });

                    const newActiveThumb = document.querySelector(`.product__thumb-item[data-thumb-varinat*="${variantId}"]`);

                    if (newActiveThumb && activeThumb !== newActiveThumb) {
                        if (activeThumb) {
                            activeThumb.classList.remove('active-thumb');
                        }
                        newActiveThumb.classList.add('active-thumb');
                        activeThumb = newActiveThumb;
                    }

                } else {
                    console.warn(`Image with data-variant-id="${variantId}" not found for scrolling.`);
                }

            }, 200); // give DOM time to update
        };

        const variantRadioButtons = document.querySelectorAll('input[type="radio"]');
        const variantIdInput = document.querySelector('[name="id"]');


        if (variantRadioButtons.length > 0 && variantIdInput) {
            variantRadioButtons.forEach(radio => {
                radio.addEventListener('change', () => {
                    setTimeout(() => {
                        const currentVariantId = variantIdInput.value;
                        if (currentVariantId) {
                            scrollToVariantImage(currentVariantId);
                        }
                    }, 0); 
                });
            });
        }
      }
      
  }

  connectedCallback() {
    var ThumbSwiper = new Swiper(".js-thum-carousel", {
      spaceBetween: 10,
      slidesPerView: 4,
      breakpoints: {
        0: {
          direction: "horizontal",
          slidesPerView: 4,
        },
        769: {
          direction: "vertical",
          slidesPerView: 4,
        }
      }
    });

   // Function to update the MainSwiper when a variant is selected
function updateSwiperForVariant(variantId) {
    // 1. Find the target slide element within the Swiper container 
    //    that matches the selected variant ID.
    // NOTE: This requires your swiper-slide elements to have the data-variant-id attribute.
    const targetSlide = document.querySelector(`.js-product-carousel .swiper-slide[data-variant-id="${variantId}"]`);

    if (targetSlide) {
        // 2. Get the index of the target slide relative to its parent (the swiper-wrapper)
        const swiperWrapper = targetSlide.parentElement;
        const targetSlideIndex = Array.from(swiperWrapper.children).indexOf(targetSlide);

        // 3. Slide the main Swiper to the found index.
        if (targetSlideIndex !== -1) {
            // MainSwiper must be accessible in this scope.
            if (typeof MainSwiper !== 'undefined') {
                // The 500ms is the speed of the transition.
                MainSwiper.slideTo(targetSlideIndex, 500); 
                console.log(`Swiping to slide index: ${targetSlideIndex} for Variant ID: ${variantId}`);
            } else {
                console.error("MainSwiper is not defined. Ensure Swiper is initialized before this function runs.");
            }
        }
    } else {
        console.log(`No slide found for Variant ID: ${variantId}`);
    }
}


// Your Swiper Initialization
var MainSwiper = new Swiper(".js-product-carousel", {
    slidesPerView: "auto",
    spaceBetween: 10,
    breakpoints: {
        // Mobile screen configuration (max 768px)
        0: { 
            direction: "horizontal", 
            slidesPerView: 1.20685,
            spaceBetween: 10,
            slidesOffsetAfter: 30,
        },
        // Desktop/Tablet configuration (min 769px)
        769: {
            direction: "vertical",
            spaceBetween: 30,
        }
    },
    
    thumbs: {
        // Assuming ThumbSwiper is initialized elsewhere and is available
        swiper: ThumbSwiper,
    },
});

// Event Listener for Shopify Variant Selection
// This targets the standard Shopify product selector dropdown/input
const variantSelect = document.querySelector('[name="id"]');

if (variantSelect) {
    variantSelect.addEventListener('change', function() {
        // The .value property gives the selected variant ID
        const selectedVariantId = this.value;
        
        // Ensure the variant ID is a string if needed, or just pass the value
        updateSwiperForVariant(selectedVariantId);
    });
    
    // Optional: Run on page load to set the initial image correctly
    // updateSwiperForVariant(variantSelect.value);
} 
// If you are using radio buttons or custom variant selectors, 
// replace the listener above with one that targets those elements 
// and correctly extracts the variant ID (e.g., from a data attribute).
  }

}
customElements.define('main-product-carousel', MainProductCarousel);

class AnimateAccordion extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.details-content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.content.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.closeOtherAccordions();
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  closeOtherAccordions() {
    document.querySelectorAll('acordion-animated details[open]').forEach((openDetail) => {
      if (openDetail !== this.details) {
        openDetail.removeAttribute('open');
      }
    });
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.content.offsetHeight}px`;
    const endHeight = `0px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.content.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease',
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const startHeight = `0px`;
    const endHeight = `${this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.content.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.content.style.height = '';
    this.content.style.overflow = '';
  }
}

customElements.define('acordion-animated', AnimateAccordion);




if (!customElements.get('swym-header-icon')) {
    class SwymHeaderIcon extends HTMLElement {
      constructor() {
        super();
        if (!window.SwymCallbacks) window.SwymCallbacks = [];
        window.SwymCallbacks.push(this._initializeSwymButton.bind(this));
      }

      async _initializeSwymButton(swat) {
        this.button = this.querySelector('button');
        this.counter = this.querySelector('.swym-wishlist-header-counter');

        this.button.addEventListener('click', () => {
          swat.ui.open();
        });

        if (this.counter) {
          const listData = await new Promise((resolve, reject) => {
            swat.fetchLists({
              callbackFn: data => resolve(data),
              onError: err => reject(err)
            });
          });

          let count = 0;
          for (const list of listData) {
            if (Array.isArray(list.listcontents)) {
              count += list.listcontents.length;
            }
          }

          this.counter.textContent = count;
          this.counter.style.display = count > 0 ? 'inline-flex' : 'none';
          swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
            const curr = +this.counter.textContent || 0;
            this.counter.textContent = curr + 1;
            this.counter.style.display = 'inline-flex';
          });

          swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, () => {
            const curr = +this.counter.textContent || 0;
            const newCount = curr - 1;
            this.counter.textContent = newCount > 0 ? newCount : '';
            if (newCount <= 0) this.counter.style.display = 'none';
          });
        }
      }
    }
    customElements.define('swym-header-icon', SwymHeaderIcon);
  }

class CartCounter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateCartCount();

    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', () => {
        setTimeout(() => this.updateCartCount(), 400);
      });
    });

    this.interceptCartRequests();
  }

  interceptCartRequests() {
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const url = args[0];
      const isCartAdd = typeof url === 'string' && url.includes('/cart/add');

      return originalFetch(...args).then(res => {
        if (isCartAdd) {
          setTimeout(() => this.updateCartCount(), 300);
        }
        return res;
      });
    };
  }

  updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-bubble').forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }
}

customElements.define('cart-counter', CartCounter);

const announcementBarId = document.querySelector(".announcement-bar");
  setTimeout(() => {
   announcementBarId.classList.remove("hidden");
  }, 100);


if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
  console.log(" Dark mode preferred");
  const darkmode = document.querySelector(".light-mode");
  if (darkmode) {
    darkmode.classList.remove("hide");
    console.log("******", darkmode);
  }
} else {
  console.log("Light mode preferred");
  const lightmode = document.querySelector(".dark-mode");
  if (lightmode) {
    console.log("========", lightmode);
    lightmode.classList.remove("hide");
  }
}


class LoadMoreGrid extends HTMLElement {
  constructor() {
    super();
    this.btn = null;
    this.grid = null;
    this.currentPage = 1;
  }

  connectedCallback() {
    this.btn = this.querySelector('#load-more-btn');
    // It looks for a grid inside the component, or you can pass an ID via attribute
    const gridId = this.getAttribute('grid-id') || 'product-grid';
    this.grid = document.getElementById(gridId);

    if (this.btn && this.grid) {
      this.currentPage = parseInt(this.btn.dataset.page) || 1;
      this.btn.addEventListener('click', () => this.loadMore());
    }
  }

  async loadMore() {
    const totalItems = parseInt(this.btn.dataset.totalItems);
    const productsPerPage = parseInt(this.btn.dataset.productsPerPage);
    const nextPage = this.currentPage + 1;
    
    // Build URL - preserve all query parameters
    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);

    this.toggleLoading(true);

    try {
      const response = await fetch(url.href);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const fetchedGrid = doc.getElementById(this.grid.id);

      if (!fetchedGrid) throw new Error('Target grid not found in response');

      // Check if Load More button exists on the next page
      const nextPageLoadMoreBtn = doc.querySelector('#load-more-btn');

      // Get all children from fetched grid
      const newProducts = Array.from(fetchedGrid.children);
      
      // Count appended products
      let appendedCount = 0;
      
      newProducts.forEach(element => {
        // Skip banners and load-more containers
        if (!element.classList.contains('collection-banner') && 
            !element.classList.contains('load-more-container')) {
          
          // Check for duplicates using product ID
          const productId = element.dataset.productId || element.querySelector('[data-product-id]')?.dataset.productId;
          
          if (productId) {
            const exists = this.grid.querySelector(`[data-product-id="${productId}"]`);
            if (!exists) {
              this.grid.appendChild(element.cloneNode(true));
              appendedCount++;
            }
          } else {
            // If no product ID system, just append
            this.grid.appendChild(element.cloneNode(true));
            appendedCount++;
          }
        }
      });

      console.log('Products appended:', appendedCount);
      console.log('Expected products per page:', productsPerPage);

      this.currentPage = nextPage;
      this.btn.dataset.page = nextPage;

      // HIDE BUTTON IF:
      // 1. No products were appended (empty page), OR
      // 2. The fetched page doesn't have a Load More button, OR
      // 3. Appended products are less than productsPerPage (last page with remaining items), OR
      // 4. We've loaded all products based on calculation
      if (appendedCount === 0 || 
          !nextPageLoadMoreBtn || 
          appendedCount < productsPerPage ||
          (productsPerPage * this.currentPage) >= totalItems) {
        this.btn.style.display = 'none';
        console.log('Last page reached - hiding button');
      }

    } catch (error) {
      console.error('Load More Error:', error);
      this.btn.textContent = 'Error Loading Products';
      setTimeout(() => this.toggleLoading(false), 2000);
    } finally {
      this.toggleLoading(false);
    }
  }

  toggleLoading(isLoading) {
    this.btn.textContent = isLoading ? 'Loading...' : 'View More';
    this.btn.disabled = isLoading;
  }
}

customElements.define('load-more-grid', LoadMoreGrid);

class LoadMoreBannerGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('#load-more-btn');
      if (button && this.contains(button)) {
        this.loadMore(button);
      }
    });
  }

  async loadMore(button) {
    const gridId = this.getAttribute('grid-id') || 'product-grid';
    const productGrid = document.getElementById(gridId);
    
    if (!productGrid) {
      console.error('Product grid not found:', gridId);
      return;
    }

    let currentPage = parseInt(button.dataset.page) || 1;
    const nextPage = currentPage + 1;
    const productsPerPage = parseInt(button.dataset.productsPerPage) || 20;

    // Build URL including active filters
    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);

    button.textContent = 'Loading...';
    button.disabled = true;

    try {
      const response = await fetch(url.href);
      if (!response.ok) throw new Error('Network error');
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const fetchedGrid = doc.getElementById(gridId);
      const nextPageLoadMoreBtn = doc.querySelector('#load-more-btn');

      if (!fetchedGrid) {
        console.error('Fetched grid not found');
        return;
      }

      // Get all children from fetched grid
      const newItems = Array.from(fetchedGrid.children);
      
      console.log('Found items to append:', newItems.length);

      // Filter out banners and append products
      let appendedCount = 0;
      newItems.forEach(element => {
        // Skip banners and load-more containers
        if (!element.classList.contains('collection-banner') && 
            !element.classList.contains('load-more-container')) {
          
          // Additional check: avoid duplicates by checking data-product-id or similar
          const productId = element.dataset.productId || element.querySelector('[data-product-id]')?.dataset.productId;
          
          if (productId) {
            const exists = productGrid.querySelector(`[data-product-id="${productId}"]`);
            if (!exists) {
              productGrid.appendChild(element.cloneNode(true));
              appendedCount++;
            }
          } else {
            // If no product ID system, just append
            productGrid.appendChild(element.cloneNode(true));
            appendedCount++;
          }
        }
      });

      console.log('Products appended:', appendedCount);
      console.log('Expected products per page:', productsPerPage);

      // Update current page
      button.dataset.page = nextPage;

      // HIDE BUTTON IF:
      // 1. No products were appended (empty page), OR
      // 2. The fetched page doesn't have a Load More button, OR
      // 3. Appended products are less than productsPerPage (last page with remaining items)
      if (appendedCount === 0 || !nextPageLoadMoreBtn || appendedCount < productsPerPage) {
        const container = button.closest('.load-more-container');
        if (container) {
          container.style.display = 'none';
        }
        console.log('Last page reached - hiding button. Reason:', 
          appendedCount === 0 ? 'No products' : 
          !nextPageLoadMoreBtn ? 'No button on next page' : 
          'Less than ' + productsPerPage + ' products loaded');
      } else {
        button.textContent = 'View More';
        button.disabled = false;
      }

    } catch (error) {
      console.error('Load More Error:', error);
      button.textContent = 'View More';
      button.disabled = false;
    }
  }
}

if (!customElements.get('load-more-banner-grid')) {
  customElements.define('load-more-banner-grid', LoadMoreBannerGrid);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.variant-btn');

    this.init();
  }
  connectedCallback() {
    this.paymentButtons = document.querySelector('.payment-buttons');

    if (!this.paymentButtons) return;

    window.addEventListener('scroll', () => {
      this.checkVisibility();
    });

    this.checkVisibility();
  }

  init() {
    this.buttons.forEach((btn) => {

      btn.addEventListener('click', () => {

        const handle = btn.dataset.handle;
        const value = btn.dataset.value;
        const varinat_id = btn.dataset.id;

        console.log("Sticky button clicked");
        console.log("Handle:", handle);
        console.log("Value:", value);

        this.setActive(btn);
        this.triggerOriginalVariant(handle, value, varinat_id);

      });

    });
  }

  setActive(button) {

    const group = button.closest('.sticky-option-values');

    group.querySelectorAll('.variant-btn').forEach(b => {
      b.classList.remove('active');
    });

    button.classList.add('active');
  }

  triggerOriginalVariant(handle, value, varinat_id) {

    const radios = document.querySelectorAll(".variant-input");

      radios.forEach((radio) => {

        const radio_handle = radio.name;
        const radio_value = radio.dataset.value;
        const cart_form = this.querySelector(".sticky-atc-form input[name='id']");
        cart_form.value = varinat_id;

        const radio_input = radio.querySelector("input");  
        if ( radio_value === value) {
          radio_input.click();

        }

      });

  }

  checkVisibility(){
     const rect = this.paymentButtons.getBoundingClientRect();

    const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (inView) {
      this.classList.remove('active');
    } else {
      this.classList.add('active');
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);